module.exports = __webpack_public_path__ + "static/media/spet_figura_1.b7ee1b38.png";